// extracted by mini-css-extract-plugin
module.exports = {"section__wrapper":"ArticleSlider-module--section__wrapper--1WIol","articleslider__wrapper":"ArticleSlider-module--articleslider__wrapper--Ez2Cf"};